
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","viewBox":"0 0 16 17","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M13.135 9.91l-3.97 3.97a1.107 1.107 0 01-1.567 0L2.84 9.128V3.59H8.38l4.756 4.757c.43.432.43 1.13 0 1.562z","stroke":"currentColor","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.673 7.423h.007","stroke":"currentColor","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    